<app-tabs (tabSelected)="onTabSelection($event)">
  <app-tab [tabIndex]="addressTabIndex.Search" [title]="'Find address'">
    <ng-content select="[search-address-tab]" />
  </app-tab>

  <app-tab [tabIndex]="addressTabIndex.Manual" [title]="'Manual address'">
    <ng-content select="[manual-address-tab]" />
  </app-tab>
</app-tabs>
